/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialAdvisorDtoSearchResponse } from '../../models/financial-advisor-dto-search-response';

export interface SearchFinancialAdvisors$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
}

export function searchFinancialAdvisors(http: HttpClient, rootUrl: string, params?: SearchFinancialAdvisors$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialAdvisorDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchFinancialAdvisors.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialAdvisorDtoSearchResponse>;
    })
  );
}

searchFinancialAdvisors.PATH = '/api/financial-advisor';
